import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const getListsMeta = () => {
	return axios.get('/api/list')
}

export const getList = (type = '', query) => {
	return axios.get(`/api/list/${type}`, { params: query })
}

/**
 * @returns {Promise<Object>}
 */
export const getSortList = (name, sources) => {
	return axios.get(`api/${name}/sort-list?source=${sources}`)
}
